import { Controller } from "@hotwired/stimulus"

/**
 * 入出庫情報確認用のStimulusコントローラー
 */
export default class extends Controller {
  static values = { confirmMessage: String, deliveryId: String }

  connect() {
    this.pendingRequest = null
  }

  /**
   * チェックボタンクリック時にフォームを送信（確認処理）
   */
  async submitForm() {
    if (!confirm(this.confirmMessageValue)) {
      return
    }

    // セッション更新リクエストの完了を待つ
    if (this.pendingRequest) {
      await this.pendingRequest
    }

    const form = document.getElementById('delivery-confirmation-form')
    if (form) {
      form.requestSubmit()
    }
  }

  /**
   * チェックボックス変更時にセッションを更新（fetch）
   */
  submitForSessionUpdate(event) {
    const checkbox = event.target
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || ''

    this.pendingRequest = fetch('/delivery_confirmations/update_session_item', {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': csrfToken
      },
      body: new URLSearchParams({
        delivery_id: this.deliveryIdValue,
        item_id: checkbox.dataset.itemId,
        is_checked: checkbox.checked
      })
    }).finally(() => {
      this.pendingRequest = null
    })
  }

  /**
   * 明細編集モーダルを開く
   */
  openEditModal(event) {
    const params = new URLSearchParams({
      delivery_id: this.deliveryIdValue,
      item_id: event.params.itemId,
      delivery_detail_id: event.params.deliveryDetailId,
      item_type: event.params.itemType
    })
    const url = `/delivery_confirmations/open_modal?${params}`
    Turbo.visit(url, { frame: 'detail_modal' })
  }

  /**
   * イベント伝播を止める（チェックボックスクリック時）
   */
  stopPropagation(event) {
    event.stopPropagation()
  }
}
